<template>
  <Card :class="[`${$route.name.split('-').shift()}-mutate-customfields`]">
    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemasComp"
      :data="value"
      :placement="customFieldsPlacement"
      :validator="validator"
      validator-prefix="customFields"
      :components="customComponents"
    />
  </Card>
</template>

<script>
import Card from '@/components/Card'
import CustomFields from '@kvass/custom-fields'
import ProjectList from '@/components/CustomFields/ProjectList'
import { mergeDeepRight } from 'ramda'

const meta = {
  skip: true,
}

export { meta }
export default {
  props: {
    value: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    customFieldsPlacement: String,
    isActive: Boolean,
  },
  computed: {
    customComponents() {
      return [ProjectList]
    },
    customFieldSchemasComp() {
      return this.customFieldSchemas.map(item => {
        return mergeDeepRight(item, { options: { props: { ...item.options.props, parentIsActive: this.isActive } } })
      })
    },
  },
  components: {
    Card,
    CustomFields,
  },
}
</script>
